import { Component } from '@theme/component';
/** Accessible tabs; native details owns the Read more interaction. */
class FragranceDetails extends Component {
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    const tabs = [...this.querySelectorAll('[role="tab"]')];
    if (tabs.length !== 2) return;
    const activate = (tab, focus = false) => {
      for (const item of tabs) {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
        if (panel) panel.hidden = !selected;
      }
      if (focus) tab.focus();
    };
    for (const details of this.querySelectorAll('.gf-fragrance-details__read-more')) {
      const summary = details.querySelector('summary');
      if (!summary?.dataset.more) continue;
      details.addEventListener('toggle', () => { summary.textContent = details.open ? summary.dataset.less : summary.dataset.more; }, {signal:this.#abort.signal});
    }
    this.dataset.enhanced = '';
    activate(tabs[0]);
    for (const tab of tabs) {
      tab.addEventListener('click', () => activate(tab), {signal:this.#abort.signal});
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowLeft' ? -1 : 1) + tabs.length) % tabs.length;
        activate(tabs[index], true);
      }, {signal:this.#abort.signal});
    }
  }
  disconnectedCallback() { this.#abort?.abort(); super.disconnectedCallback(); }
}
if (!customElements.get('gf-fragrance-details')) customElements.define('gf-fragrance-details', FragranceDetails);
